import { EarningsInsightRating } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './RatingPill.styles';
import { getRatingColors } from './utils';

export interface RatingPillProps {
  rating: EarningsInsightRating;
}

export const RatingPill = ({ rating }: RatingPillProps) => {
  const { t } = useTranslation(['earnings']);
  const { backgroundColor, textColor } = getRatingColors(rating);

  return (
    <S.RatingWrapper $bgColor={backgroundColor}>
      <S.RatingLabel $textColor={textColor}>
        {t(`earnings:earningsInsight.metadata.rating.${rating}`)}
      </S.RatingLabel>
    </S.RatingWrapper>
  );
};
